import { Component, inject } from '@angular/core';
import { LanguageService } from '../../../services/language.service';
import { UserService } from '../../../services/user/user.service';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import {
  NotificationSidebarComponent,
} from '../../modules/notification-center/notification-sidebar/notification-sidebar.component';
import { HeaderBalanceComponent } from '../../components/header-balance/header-balance.component';
import { BtnComponent } from '../../components/btn/btn.component';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BurgerMenuComponent } from '../../components/burger-menu/burger-menu.component';
import { NgClass } from '@angular/common';
import { isMobile } from '../../../signals/device';
import { GameFilterService } from '../../../services/games/game-filter.service';
import { SeoService } from '../../../services/seo.service';
import { AppShellNoSSRDirective } from 'ngx-unificator/directives';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    BurgerMenuComponent,
    RouterLinkActive,
    RouterLink,
    RouterLinkDirective,
    NgClass,
    BtnComponent,
    HeaderBalanceComponent,
    AppShellNoSSRDirective,
    NotificationSidebarComponent,
    TranslatePipe,
    AppShellNoSSRDirective,
  ],
})
export class HeaderComponent {
  lang = inject(LanguageService);
  user = inject(UserService);
  gamesFilters = inject(GameFilterService);
  seo = inject(SeoService);


  public onClickSearch() {
    this.gamesFilters.toggleSearchPopup();
  }

  protected readonly isMobile = isMobile;
}
